import getLocalStorage from './src/local-storage';
import getMemoryStorage from './src/memory-storage';
import getSessionStorage from './src/session-storage';

export {
  getLocalStorage,
  getMemoryStorage,
  getSessionStorage
};
